'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';

import {applicationModel} from "../../models/applicationmodel.js";

export class ApplicationListSiteCtrl extends ListCtrl
{
	storageNames = {
		query: 'ApplicationsListCtrlQuery'
	};

	constructor($scope, $http, $filter, $timeout, $locale, jsDataService){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
		this.storageNames.query = this.jsDataService.get('cfgQueryStorageKey', '');

		if(this.classif.users){
			for(const user of this.classif.users) {
				user.title = `${user.name} ${user.lastname}`;
			}
		}
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new applicationModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof applicationModel){
			return row.getValue(col);
		}
		return row[col];
	}
	
	getFooterData(col){
		if(typeof(this.columnsData.footer[col]) !== 'undefined'){
			switch(col){
				case 'a1_general_amount':
					return this.$filter('currency')(this.columnsData.footer[col].value);
			}
			return this.columnsData.footer[col].value;
		}
		return '';
	}
	
	exportList(){
		const query = new URLSearchParams({
			filters: JSON.stringify(this.query.filters),
			limit: this.query.limit,
			page: this.query.page,
			order: this.query.order,
		});
		
		const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');
		
		const a = document.createElement('a');
		a.style.display = 'none';
		a.href = `${this.cfgExportUrl}?${query.toString()}`;
		a.download = `Applications_${ts}.xlsx`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
	
}


